import './suspense.css';

import { Warning } from "phosphor-react-sc"
import ContentGrid from "../ContentGrid"


interface ErrorBoundryFallbackProps {
    title?: string,
    titleIcon?: string,
    mode?: string,
    text?: string
}

export const ErrorBoundryFallback = ({
    title = "",
    titleIcon = "",
    mode = "title",
    text = ""
}: ErrorBoundryFallbackProps) => {

    return (
        (() => {
            switch (mode) {
                case "text":
                    return (
                        <div className="suspense-content">
                            <div style={{ background: "#b91d47", color: "#ffffff" }}>
                                <div><Warning size="32"/></div>
                                <div>{text}</div>
                            </div>
                        </div>
                    )
                default:
                    return (
                        <ContentGrid
                            title={title}
                            titleIcon={titleIcon}>
                            <h4>{text}</h4>
                        </ContentGrid>
                    )

            }
        })()
    )
}
